import { ContractStatusBadge } from "../../common/components/ContractStatusBadge";
import { isoToDate } from "../../helpers/helpers";

export const ContractDetailList = ({ contract }) => {
  const isAssignedToResource = contract?.is_assigned_to_resource === true;
  const dateSince = isAssignedToResource
    ? contract?.contract_assign_date_in
    : contract?.contract_date_in;
  const dateUntil = isAssignedToResource
    ? contract?.contract_assign_date_out
    : contract?.contract_date_out;

  return (
    <tr className="text-center">
      <td className="custom-border">
        <p className="m-0">{contract?.contract_code}</p>
      </td>
      <td className="custom-border">
        <p className="m-0">{contract?.contract_description}</p>
      </td>
      <td className="custom-border">
        <p className="m-0">
          {contract?.opening ? contract.opening?.opening_description : "-"}
        </p>
      </td>
      <td className="custom-border">
        <p className="m-0">{dateSince ? isoToDate(dateSince) : "-"}</p>
      </td>
      <td>
        <p className="m-0">{dateUntil ? isoToDate(dateUntil) : "-"}</p>
      </td>
      <td>
        <ContractStatusBadge contractStatus={contract?.contract_general_status} />
      </td>
    </tr>
  );
};
